import React, { useContext, useState } from "react";
import { RICOS_ANCHOR_TYPE, RICOS_LINK_TYPE } from "./../../ricos-content";
import { EditorContext, ModalServiceContext, ToolbarContext } from "./../../ricos-context";
import { getIsModalOpen, useModalState } from "./../../ricos-modals/modal-service-provider";
import { LINK_MODAL_ID } from "./../../_shared/link-modal/constants";
import { toggleLinkModal } from "./../../_shared/link-modal/toggle-link-modal";
import { ToolbarButton } from "./../../toolbars-ui";
const EditLinkButton = ({ toolbarItem }) => {
  const { getPublicCommands } = useContext(EditorContext);
  const { isMobile, t } = useContext(ToolbarContext);
  const modalService = useContext(ModalServiceContext) || {};
  const isModalOpen = useModalState(getIsModalOpen(LINK_MODAL_ID));
  const [referenceElement, setReferenceElement] = useState(null);
  const publicCommands = getPublicCommands();
  const openModal = () => {
    toggleLinkModal({
      initialValue: publicCommands.getLinkDataInSelection(),
      modalService,
      onSave: (link) => {
        publicCommands.insertDecoration(link.anchor ? RICOS_ANCHOR_TYPE : RICOS_LINK_TYPE, link);
      },
      onUnlink: (link) => {
        publicCommands.deleteDecoration(link.anchor ? RICOS_ANCHOR_TYPE : RICOS_LINK_TYPE);
      },
      referenceElement
    });
  };
  return /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      ref: setReferenceElement,
      isMobile,
      active: isModalOpen || toolbarItem.attributes.active,
      tooltip: t(toolbarItem.presentation?.tooltip),
      onClick: openModal,
      Icon: toolbarItem.presentation?.icon,
      dataHook: toolbarItem.presentation?.dataHook
    }
  );
};
export {
  EditLinkButton
};
//# sourceMappingURL=edit-link-button.js.map
